export default function(query, urlValue) {
  const url = new URL(urlValue);
  const params = new URLSearchParams(url.search.slice(1));
  params.append("q", query);
  url.search = params.toString();

  return url.toString();
}
